import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleNewsletterSubmit = async (e) => {
    e.preventDefault();
    const response = await fetch('https://formspree.io/f/xkgbrkze', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email }),
    });
    if (response.ok) setSubscribed(true);
  };

  return (
    <footer className="bg-gray-900 text-white px-4 py-12 md:px-8 lg:px-16">
      <div className="container mx-auto">
        {/* Grid principale */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-10">
          
          {/* Bloc 1 : Description et coordonnées */}
          <div className="space-y-4">
            <h2 className="text-2xl font-bold text-blue-400">FRANCE ETUDES</h2>
            
            <div className="space-y-2 text-sm">
              <div className="flex items-start gap-3">
                <FaMapMarkerAlt className="text-blue-400 mt-1 flex-shrink-0" />
                <span className="text-gray-300">03 rue Bomitaba, avenue Maya Maya, 1er étage, Moungali</span>
              </div>
              <div className="flex items-center gap-3">
                <FaPhoneAlt className="text-blue-400" />
                <span className="text-gray-300">+33 7 58 72 82 89/+242 06 172 81 62</span> 
              </div>
              <div className="flex items-center gap-3">
                <FaEnvelope className="text-blue-400" />
                <span className="text-gray-300">contact@franceetudes.com</span>
              </div>
              <div className="flex gap-4 pt-2">
                <a href="https://www.facebook.com/share/1GTTGgXk35/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">
                  <FaFacebookF />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">
                  <FaTwitter />
                </a>
                <a href="https://www.instagram.com/lmk_travel_cg/profilecard/?igsh=bGk4NW5vNmdqOGt6" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-blue-400 transition-colors">
                  <FaInstagram />
                </a>
              </div>
            </div>
          </div>

          
          {/* Bloc 2 : Liens rapides */}
          {/* <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b border-gray-700">Liens rapides</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/tarifs" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                  Tarifications
                </Link>
              </li>
              <li>
                <Link to="/formations" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                  Formations
                </Link>
              </li>
            </ul>
          </div> */}

          {/* Bloc 3 : Pages utiles */}
          <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b border-gray-700">Pages utiles</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/blog" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-blue-400 transition-colors flex items-center gap-2">
                  <span className="w-2 h-2 bg-blue-400 rounded-full"></span>
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Bloc 4 : Réseaux sociaux et Newsletter */}
          <div>
            <h3 className="text-lg font-semibold mb-4 pb-2 border-b border-gray-700">Suivez-nous</h3>
            
            {/* Newsletter */}
            <div className="mb-6">
              <h4 className="text-sm font-medium mb-3">Inscrivez-vous à notre newsletter</h4>
              {subscribed ? (
                <p className="text-green-400">Merci pour votre inscription !</p>
              ) : (
                <form onSubmit={handleNewsletterSubmit} className="flex flex-col gap-2"  action="https://formspree.io/f/xkgbrkze"
                method="POST">
                  <input 
                    type="email" 
                    placeholder="Votre adresse email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="px-3 py-2 bg-gray-800 border border-gray-700 rounded-md text-sm focus:outline-none focus:border-blue-400"
                    required
                  />
                  <button 
                    type="submit" 
                    className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded-md text-sm transition-colors"
                  >
                    S'inscrire
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} France études. Tous droits réservés. | 
            <a href="#" className="hover:text-blue-400 ml-2">Design by consulting informatic's</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;